<template>
  <a-modal
    v-model:visible="visible"
    :width="418"
    :mask="false"
    wrap-class-name="modal-images"
  >
    <p class="text-sm ml-25 mt-7">图组需要绑定数据源使用</p>

    <template #footer>
      <a-button type="primary" @click="handleOk"> 去绑定 </a-button>
    </template>
  </a-modal>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue';
const emits = defineEmits<{
  (event: 'on-ok'): void;
}>();

const visible = ref<boolean>(false);
const showModal = () => {
  visible.value = true;
};

const handleOk = () => {
  visible.value = false;
  emits('on-ok');
};
defineExpose({ open: showModal });

const handleKeyUp = (e: KeyboardEvent) => {
  e.stopPropagation();
  if (e.key === 'Enter') {
    handleOk();
  }
};

watch(visible, (val) => {
  if (val) window.addEventListener('keyup', handleKeyUp);
  else window.removeEventListener('keyup', handleKeyUp);
});
</script>

<style lang="less">
.modal-images {
  .ant-modal-content {
    background-color: #000000;
    border-radius: 16px;
    height: 167px;
    border: 1px solid #333333;
    top: 230px !important;
    right: calc(-50vw + 570px);
    .ant-modal-footer {
      position: absolute;
      bottom: 1px;
      left: 154px;
    }
  }
}
</style>
